// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

var waypoints_attributes_encode = Decco.stringToJson;

var value_added_services_encode = Decco.stringToJson;

function order_encode(v) {
  return Js_dict.fromArray([
              [
                "customer_mobile",
                Decco.stringToJson(v.customer_mobile)
              ],
              [
                "geo_region_id",
                Decco.intToJson(v.geo_region_id)
              ],
              [
                "from_address_lat",
                Decco.floatToJson(v.from_address_lat)
              ],
              [
                "from_address_long",
                Decco.floatToJson(v.from_address_long)
              ],
              [
                "to_address_lat",
                Decco.floatToJson(v.to_address_lat)
              ],
              [
                "to_address_long",
                Decco.floatToJson(v.to_address_long)
              ],
              [
                "waypoints_attributes",
                Decco.arrayToJson(waypoints_attributes_encode, v.waypoints_attributes)
              ],
              [
                "value_added_services",
                Decco.arrayToJson(value_added_services_encode, v.value_added_services)
              ],
              [
                "payment_mode",
                Decco.stringToJson(v.payment_mode)
              ],
              [
                "business_order_info",
                Decco.optionToJson(Decco.stringToJson, v.business_order_info)
              ],
              [
                "use_porter_credits",
                Decco.boolToJson(v.use_porter_credits)
              ]
            ]);
}

function quotations_request_encode(v) {
  return Js_dict.fromArray([
              [
                "mobile",
                Decco.stringToJson(v.mobile)
              ],
              [
                "n_waypoints",
                Decco.intToJson(v.n_waypoints)
              ],
              [
                "vehicle_ids",
                Decco.arrayToJson(Decco.intToJson, v.vehicle_ids)
              ],
              [
                "order",
                order_encode(v.order)
              ],
              [
                "service_type",
                Decco.optionToJson(Decco.stringToJson, v.service_type)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "mobile",
                Decco.stringToJson(v.mobile)
              ],
              [
                "coupon_code",
                Decco.optionToJson(Decco.stringToJson, v.coupon_code)
              ],
              [
                "vehicle_id",
                Decco.intToJson(v.vehicle_id)
              ],
              [
                "quotations_request",
                quotations_request_encode(v.quotations_request)
              ]
            ]);
}

export {
  waypoints_attributes_encode ,
  value_added_services_encode ,
  order_encode ,
  quotations_request_encode ,
  t_encode ,
  
}
/* No side effect */
